import {useState, useEffect} from "react";
import {
  ISectorDataFromServer,
  ITrendDataFromServer,
} from "../pages/Fintech/FintechDashboard.type";
import {getFintechTrendsCount} from "../helper/api";

const useFetchDataFintech = (
  apiUrlTrends: string,
  apiUrlSectors: string,
  apiKey: string
) => {
  const [trendsData, setTrendsData] = useState<ITrendDataFromServer | null>(
    null
  );
  const [sectorsData, setSectorsData] = useState<ISectorDataFromServer | null>(
    null
  );
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const headers = new Headers({
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    });

    const trendsUrl = new URL(apiUrlTrends);
    const sectorsUrl = new URL(apiUrlSectors);

    trendsUrl.searchParams.set("populate", "*");
    trendsUrl.searchParams.set(
      "pagination[pageSize]",
      getFintechTrendsCount?.toString() || "100"
    );
    sectorsUrl.searchParams.set("populate", "*");

    Promise.all([
      fetch(trendsUrl.href, {headers}).then((response) => response.json()),
      fetch(sectorsUrl.href, {headers}).then((response) => response.json()),
    ])
      .then(([trendsData, sectorsData]) => {
        setTrendsData(trendsData);
        setSectorsData(sectorsData);
      })
      .catch((error) => {
        setError(error);
      });
  }, [apiUrlTrends, apiUrlSectors, apiKey]);
  return {trendsData, sectorsData, error};
};

export default useFetchDataFintech;
